import React, { useContext } from 'react'
import SearchFieldsContext from '../context/context'
import SimpleDateField from '../../Custom/CustomInput/SimpleDateField'

const ListingStatusFilter = () => {
    const { searchFields, setSearchFields } = useContext(SearchFieldsContext)
    // const [filterOptions] = React.useState(searchFields.listingStatusFields)

    // console.log('searchFields.listingStatusFields::', searchFields.listingStatusFields)
    function handleChange(e) {
        const { value } = e.target
        const newSearchFields = searchFields

        const i = newSearchFields.listingStatusFields.findIndex(x => x.label === value)

        let { isChecked } = newSearchFields.listingStatusFields[i]
        isChecked = !isChecked
        newSearchFields.listingStatusFields[i] = { ...newSearchFields.listingStatusFields[i], isChecked }
        setSearchFields({ ...newSearchFields })
    }

    function handleChangeDate(e) {
        const { id, value } = e.target
        const i = searchFields.listingStatusFields.findIndex(x => x.propId === e.target.getAttribute('data-propid'))
        const newSearchFields = searchFields
        const maxInputValue = newSearchFields.listingStatusFields[i].maxInputValue ? newSearchFields.listingStatusFields[i].maxInputValue : ''
        const newValue = newSearchFields.listingStatusFields[i].type === 'date' ? value : validateInputField(value, newSearchFields.listingStatusFields[i].type, maxInputValue)

        if (newSearchFields.listingStatusFields[i].type === 'date') {
            newSearchFields.listingStatusFields[i] = id.indexOf('start') !== -1 ? { ...newSearchFields.listingStatusFields[i], startValue: newValue } : { ...newSearchFields.listingStatusFields[i], endValue: newValue }
        }
        setSearchFields({ ...newSearchFields })
    }

    return (
        <>
            <div className="flex flex-col gap-2 text-2">
                {searchFields.listingStatusFields.map(value => {
                    return (
                        <>
                            {value.type === 'date' ?
                                <>
                                    <div className="text-2">
                                        <label htmlFor={value.label}>{value.label}</label>
                                    </div>
                                    <div className="flex flex-row space-x-2 mb-3 sm:space-x-4">
                                        <SimpleDateField propid={value.propId} testid={`Start-${value.fieldName}`} onChange={handleChangeDate} type={value.type} placeholder={value.isStartEnd ? 'MM/DD/YYY' : ''} id={`start${value.propId.replace(/\s/g, '')}`} value={value.startValue} classes={value.isStartEnd ? '' : 'w-full'}></SimpleDateField>
                                        {value.isStartEnd ?
                                            <SimpleDateField propid={value.propId} testid={`End-${value.fieldName}`} onChange={handleChangeDate} type={value.type} placeholder={value.isStartEnd ? 'MM/DD/YYYY' : ''} id={`end${value.propId.replace(/\s/g, '')}`} value={value.endValue} ></SimpleDateField>
                                            : null
                                        }
                                    </div>
                                </>
                                :
                                <div className=" mb-3">
                                    <input data-testid={`test-chk-${value.fieldName}`} onChange={handleChange} checked={value.isChecked} key={value.label} id={value.label} name={value.label} type="checkbox" value={value.label} />
                                    <label className="px-3" htmlFor={value.label}>{value.label}</label>
                                </div>
                            }
                        </>
                    )
                })}
            </div>
        </>
    )
}

export default ListingStatusFilter
